import { useMemo } from "react";

import { IntlShape } from "react-intl";

const useSteps = (intl: IntlShape) =>
  useMemo(
    () => [
      intl.formatMessage({
        id: "settings.customFields.createEditPane.steps.basicInfo.title",
        defaultMessage: "Basic info",
        description: "Settings Custom field - create /edit - basic info step title",
      }),
      intl.formatMessage({
        id: "settings.customFields.createEditPane.steps.FieldSetup.title",
        defaultMessage: "Field setup",
        description: "Settings Custom field - create /edit - FieldSetup step title",
      }),
      intl.formatMessage({
        id: "settings.customFields.createEditPane.steps.shareSave.title",
        defaultMessage: "Share & save",
        description: "Settings Custom field - create /edit - Share & save step title",
      }),
    ],
    [intl]
  );

export default useSteps;
